export default __webpack_public_path__ + "static/media/cert-finance-consumer-sc.18d5aeea.jpg";